import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'dashboard_asi.mes_contracts.title',
  },
  subTitle: {
    id: 'asi_details.sub_title',
  },
  FindMoreAboutContracts: {
    id: 'asi_details.find_more_about_contracts',
  },
});
